"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var UsrPermissionEditor = /** @class */ (function (_super) {
    __extends(UsrPermissionEditor, _super);
    function UsrPermissionEditor(props) {
        return _super.call(this, props) || this;
    }
    UsrPermissionEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    comment: _item.comment,
                    is_deprecated: _item.is_deprecated,
                    start_document_url: _item.start_document_url
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование набора прав"]);
                });
            }
        }
        else {
            this.setState({
                title: "",
                comment: "",
                is_deprecated: false,
                start_document_url: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание набора прав"]);
            });
        }
        this.doReSetRules();
    };
    UsrPermissionEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            start_document_url_rules: { isError: false }
        });
    };
    UsrPermissionEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        if ((!this.state.start_document_url) || (this.state.start_document_url.length === 0)) {
            this.setState({ start_document_url_rules: { isError: true, errorMessage: "Поле [url стартовой страницы] не заполнено!" } });
            return false;
        }
        return true;
    };
    UsrPermissionEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditPermission({
                key: this.props.record.key,
                comment: this.state.comment,
                title: this.state.title,
                is_deprecated: this.state.is_deprecated,
                start_document_url: this.state.start_document_url
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Набор прав изменен!");
            });
        }
    };
    UsrPermissionEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddPermission({
                comment: this.state.comment,
                title: this.state.title,
                // is_public: this.state.is_public,
                is_deprecated: this.state.is_deprecated,
                start_document_url: this.state.start_document_url
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Набор прав создан!");
            });
        }
    };
    UsrPermissionEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    UsrPermissionEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новый набор прав";
        }
        else {
            return "Изменить набор прав";
        }
    };
    UsrPermissionEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 490 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) { _this.setState({ title: newVal, title_rules: { isError: false } }); }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Url начальной страницы:", placeholder: "Введите url начальной страницы" }, value: this.state.start_document_url, onValueChanged: function (newVal) { _this.setState({ start_document_url: newVal, start_document_url_rules: { isError: false } }); }, required: true, rules: this.state.start_document_url_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Комментарий:", placeholder: "Введите комментарий" }, value: this.state.comment, onValueChanged: function (newVal) { _this.setState({ comment: newVal }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Устаревший набор прав", value: this.state.is_deprecated, onChecked: function (checked) { _this.setState({ is_deprecated: checked }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return UsrPermissionEditor;
}(React.Component));
exports.default = UsrPermissionEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/usr_permissions_list/ui/component/UsrPermissionEditor.tsx
// module id = 1888
// module chunks = 0